// extracted by mini-css-extract-plugin
export var dataCell = "_n9-2";
export var dataRow = "_n9-0";
export var headerRow = "_n9-1";